import {IntlShape} from 'react-intl';
import {HowDoesItWorkContentItem} from './HowDoesItWorkPoints/HowDoesItWorkItem';

export default (formatMessage: IntlShape['formatMessage']): HowDoesItWorkContentItem[] => [
  {
    number: 1,
    title: formatMessage({id: 'homepage.howDoesItWork.points.1.title'}),
    description: formatMessage({id: 'homepage.howDoesItWork.points.1.description'}),
  },
  {
    number: 2,
    title: formatMessage({id: 'homepage.howDoesItWork.points.2.title'}),
    description: formatMessage({id: 'homepage.howDoesItWork.points.2.description'}),
  },
  {
    number: 3,
    title: formatMessage({id: 'homepage.howDoesItWork.points.3.title'}),
    description: formatMessage({id: 'homepage.howDoesItWork.points.3.description'}),
  },
];
